import {
  ListToListMatchType,
  StringToListMatchType,
  getMatchTypeLabel,
} from "@redotech/redo-model/advanced-flow/common/condition";
import { Text } from "@redotech/redo-web/text";

export function FieldToListMatchDetails({
  field,
  fieldLabelIsPlural,
  matchValues,
  matchType,
}: {
  field: string;
  fieldLabelIsPlural: boolean;
  matchType?: ListToListMatchType | StringToListMatchType;
  matchValues?: (string | undefined)[];
}) {
  const matchTypeLabel: string | undefined = matchType
    ? getMatchTypeLabel(matchType, !fieldLabelIsPlural)
    : undefined;

  // Join all values and let CSS handle the truncation
  const displayedValues = matchValues?.join(", ") || "";

  return (
    <>
      <Text fontWeight="semibold">{field}</Text>
      <Text> </Text>
      {matchType ? matchTypeLabel : undefined}{" "}
      {matchValues?.length ? (
        <Text
          fontWeight="semibold"
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {displayedValues}
        </Text>
      ) : undefined}
    </>
  );
}
